module.exports = __webpack_public_path__ + "img/MS-M-1.3898e875.svg";